<template >
  <v-row justify="center">
    <v-dialog v-model="select.show" scrollable :max-width="maxWidth || 400">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text v-if="list" :style="{ height: height }" class="pb-0">
          <v-radio-group v-model="radioModel">
            <div
                 v-for="(item, i) in list"
                 :key="i"
                 @click="selectItem(item)"
                 class="my-2"
                 >
              <v-row>
                <v-col>
                  <v-radio :label="item.name" :value="item.code"></v-radio>
                </v-col>
                <v-col cols="4" v-if="shouldDisplayIcon(item)">
                  <!-- <v-icon>{{ getIcon(item) }}</v-icon> -->
                  <!--TODO-Conso - Insert provided icon--> <!--DONE-->
                  <v-img
                    :src="`${iconPath}accessibility-icon.png`"
                    max-height="35"
                    max-width="15"
                  ></v-img>
                </v-col>
              </v-row>
            </div>
          </v-radio-group>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closePopup">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name: "InputPopupSelectWithIcon",
    props: {
      title: String,
      list: Array,
      height: String,
      maxWidth: String,
      select: {
        show: Boolean,
        selectedItem: Object,
      },
    },
    data: () => ({
      radioModel: null,
    }),
    watch: {
      "select.show": function (newValue, oldValue) {
        //Watch for "select.show" because the radio button on time and duration list is not selected on UI
        //Can be simulated by selecting any duration other than 1 hour before selecting Bloomberg Terminal area
        //And this only works when using v-model instead of :value on v-radio-group. E.g. <v-radio-group v-model="radioModel">
        this.radioModel = this.select.selectedItem
          ? this.select.selectedItem.code
          : null;
      },
    },
    methods: {
      closePopup() {
        this.$emit("update:select", {
          show: false,
          selectedItem: this.select.selectedItem,
        });
      },
      selectItem(item) {
        this.$emit("update:select", {
          show: false,
          selectedItem: item,
        });
      },
      shouldDisplayIcon(item) {
        // Modify this function to define your criteria for displaying icons
        return item.seatInformation && item.seatInformation.isWheelchairFriendlySeat;
      },
    },
  };
</script>
